/* eslint-disable import/prefer-default-export */
// import postJson from 'FETCH/postJson';
// import { isNodeType } from 'DOM/domTypeChecking';
import fetchJson from 'UTILS/fetch/fetchJson';
import ShopifyApiError from '../ShopifyApiError';
import customErrorHandler from '../customErrorHandler';

// TODO: postFormData needs to be tested
// TODO: addToCartSerial needs to be refactored to use updated version of fetchJson
// TODO: update README.md to cover Sections param aka bundled section rendering

// ====================================================================================================================================================
// Module for export
// ====================================================================================================================================================

/**
 * Use this to add one or multiple product variants to the cart
 *
 *** IMPORTANT *** this function will accept either a product form DOM element or an object with the required props for the add to cart endpoint.
 * More info about using a form element: https://shopify.dev/docs/themes/ajax-api/reference/cart#post-cart-add-js
 *
 * postObj properties:
 * {
 *   items: [
 *     {
 *       quantity: 1,
 *       id: 794864229,
 *       properties: {
 *         'First name': 'Caroline'
 *       },
 *       selling_plan: 183638
 *     }
 *   ],
 *  sections: "cart-items,cart-icon-bubble,cart-live-region-text,cart-footer"
 * }
 * You can add multiple variants to the cart by appending more objects in the items array
 *
 * 'id' and 'quantity' are required
 * 'properties' and selling plan, and sections are optional
 * To make properties private, prepend an underscore (_) to the key
 *
 * Using the sections paramer -- aka Bundled section rendering -- allows you to request
 * the HTML markup for up to five sections you might want to update based on an initial call
 * to the Cart API, within that same call
 *
 * The sections parameter can be a comma-separated list or an array, similar to when using the Section Rendering API directly
 * For more info about using the sections parameter, see: https://shopify.dev/api/ajax/reference/cart#bundled-section-rendering
 *

 */

function transformFormData(data) {
  const payload = {};
  data.forEach((value, key) => {
    payload[key] = value;
  });
  return payload;
}

export function addToCart(item) {
  let payload = item;
  if (item instanceof FormData) {
    payload = transformFormData(item);
  }
  return fetchJson({
    url: `${window.Shopify.routes.root}cart/add.js`,
    config: {
      method: 'POST',
      body: JSON.stringify(payload),
    },
    options: {
      customErrorHandler,
      bypassErrors: [ShopifyApiError],
    },
  });
}

// const addToCart = async (item, serializedRequests = false) => {
//   if (serializedRequests) {
//     // eslint-disable-next-line no-use-before-define
//     // return addToCartSerial(obj);
//   }
//   let response;
//   try {
//     const config = {
//       method: 'POST',
//       credentials: 'same-origin',
//       headers: {
//         'Content-Type': 'application/json;',
//       },
//       // body: isNodeType(obj, 'FORM') ? new FormData(obj) : JSON.stringify(obj),
//     };
//     // const addedProductJSON = await fetchJson({
//     //   url: `${window.Shopify.routes.root}cart/add.js`,
//     //   config,
//     // });
//     // The response is only the JSON from the line items added
//     // Add a new prop for success
//     // response = { success: true, value: addedProductJSON };
//   } catch (error) {
//     response = { success: false, value: { Error: JSON.parse(error.message) } };
//   }
//   return response;
// };

// addToCartSerial is used to serialize the calls to the Shopify api.
// This is useful in situations where you don't want the api call to fail if all items aren't succesfully added to the cart.
// Use case: a bulk order form -- some items may hit quantity errors and you don't want that to prevent the success of other items
// Note: Splitting the requests using Promise.allSettled was tested & determined to not be a workable option.

// async function addToCartSerial(obj) {
//   const responses = [];

//   // eslint-disable-next-line no-plusplus
//   for (let i = 0; i < obj.items.length; i++) {
//     const request = { items: [obj.items[i]] };
//     let result;
//     // Mimic the allSettled return object with value and success keys
//     try {
//       // eslint-disable-next-line no-await-in-loop
//       result = await postJson('/cart/add.js', request);
//       responses.push({
//         success: true,
//         value: result,
//       });
//     } catch (error) {
//       responses.push({
//         success: false,
//         value: { Error: JSON.parse(error.message) },
//       });
//     }
//   }

//   return responses;
// }
